import { CONFIG_PARAMS } from '@Components/app-config/types'

export const LOCAL_HOST_CONFIG: Record<string, Record<string, string>> = {
  msl: {
    [CONFIG_PARAMS.GAME_DATA_SERVICE_URL]: 'https://test.game-data.gambytservices.com',
    [CONFIG_PARAMS.PLAYER_DATA_SERVICE_URL]: 'https://test.player-data.gambytservices.com',
    [CONFIG_PARAMS.GAME_DATA_API_KEY]:
      'ZjIyNzgwODgtZTI2Ni00Yjk0LWI2YzAtYzZiMzc5NDM0YjEwOjVSakp3K0wyRXAyM3lQMTdibnpXY21FV1ZmK0tqMm9TTC8zVHcrejNrSkU9',
    [CONFIG_PARAMS.PLAYER_DATA_API_KEY]:
      'NTgyZjE0NjEtYTcwMy00ZWRlLThmNzctYTJlNTFlOTlkZjM0OnQzb2djN1hxeTFhZlQ5OUowWHRVYXVyWDFIZFRYRFMrWTZGcGZxYTR1Rjg9',
    [CONFIG_PARAMS.CLIENT_ID]: '683fb627-b49e-4069-9e93-30e6387efba4',
    [CONFIG_PARAMS.ENABLE_CLAIM_FORM]: 'true',
  },
}
